// extracted by mini-css-extract-plugin
export var active = "_aw-7";
export var container = "_aw-0";
export var evenWidth = "_aw-4";
export var large = "_aw-5";
export var outlet = "_aw-8";
export var slide = "_aw-2";
export var small = "_aw-6";
export var tab = "_aw-3";
export var tabs = "_aw-1";